import React, { ReactElement, useEffect } from 'react'
import { useStepperContext } from '../context/StepperContext'
import { Step } from './Step'

interface StepperProps {
  steps: ReactElement | ReactElement[]
}

export const Stepper = ({ steps }: StepperProps) => {
  const { setStepsQuantity } = useStepperContext()

  const hasMultipleSteps = steps instanceof Array && steps.length > 0

  const currentSteps = hasMultipleSteps
    ? React.Children.toArray(steps)
    : [steps]

  useEffect(() => setStepsQuantity(currentSteps.length), [
    currentSteps.length,
    setStepsQuantity,
  ])

  return (
    <>
      {currentSteps.map((step, index) => (
        <Step key={index} position={index + 1}>
          {step}
        </Step>
      ))}
    </>
  )
}
